import React, { useState } from "react";
import PropTypes from "prop-types";
import { Card, CardHeader, TextInput, Toggle } from "@opendate-app/setlist";
import { updateTeamSetting } from "../../../shared/api/team";

const MAX_CUTOFF_HOURS = 720;

const ClassSelfTransferSettings = ({ teamId, initialEnabled, initialCutoffHours }) => {
  const [enabled, setEnabled] = useState(initialEnabled);
  const [savedCutoffHours, setSavedCutoffHours] = useState(initialCutoffHours);
  const [cutoffHours, setCutoffHours] = useState(String(initialCutoffHours));

  const cutoffValid = /^\d+$/.test(cutoffHours) && Number(cutoffHours) <= MAX_CUTOFF_HOURS;

  const toggle = (event) => {
    const checked = event.target.checked;
    setEnabled(checked);
    updateTeamSetting(teamId, { class_self_transfer_enabled: checked }).then((saved) => {
      if (!saved) setEnabled(!checked);
    });
  };

  const saveCutoff = () => {
    if (!cutoffValid) return;
    const hours = Number(cutoffHours);
    if (hours === savedCutoffHours) return;

    updateTeamSetting(teamId, { class_self_transfer_cutoff_hours: hours }).then((saved) => {
      if (saved) {
        setSavedCutoffHours(hours);
      } else {
        setCutoffHours(String(savedCutoffHours));
      }
    });
  };

  return (
    <div className="mt-4" data-testid="class-self-transfer-settings">
      <Card
        header={(
          <CardHeader
            title="Class transfers"
            supportingText="Let attendees move their own registration to another date of the same class from their manage registration page. They can only pick a published date with the same price and open spots, so nothing is charged or refunded."
          />
        )}
      >
        <div className="d-flex flex-column" style={{ gap: 20 }}>
          <Toggle
            id="class-self-transfer-enabled"
            label="Attendees can transfer to another date"
            checked={enabled}
            onChange={toggle}
          />
          <div style={{ maxWidth: 280 }}>
            <TextInput
              id="class-self-transfer-cutoff-hours"
              label="Transfer cutoff"
              type="number"
              min={0}
              max={MAX_CUTOFF_HOURS}
              inputMode="numeric"
              trailingText="hours before class"
              value={cutoffHours}
              disabled={!enabled}
              error={cutoffValid ? null : `Enter a whole number of hours from 0 to ${MAX_CUTOFF_HOURS}.`}
              hint="Transfers close this long before the first session starts, or at the class's refund deadline if that comes first."
              onChange={(event) => setCutoffHours(event.target.value)}
              onBlur={saveCutoff}
              data-testid="class-self-transfer-cutoff-hours"
            />
          </div>
        </div>
      </Card>
    </div>
  );
};

ClassSelfTransferSettings.propTypes = {
  teamId: PropTypes.number.isRequired,
  initialEnabled: PropTypes.bool.isRequired,
  initialCutoffHours: PropTypes.number.isRequired,
};

export default ClassSelfTransferSettings;
